//export const host = 'http://localhost:8888/';
export const host = 'https://atomicstonks.com/';
// for choosing the pricing links between test and prod
export const testmode=false;